type ConfigValues =
  | 'acoHost'
  | 'agGridLicense'
  | 'apiUrl'
  | 'appVersion'
  | 'appVersionShort'
  | 'auth0Audience'
  | 'auth0ClientId'
  | 'auth0Domain'
  | 'buildId'
  | 'buildYear'
  | 'helpscoutBeaconDefaultId'
  | 'helpscoutBeaconEsId'
  | 'lumiveroBaseUrl'
  | 'mixpanelProjectToken'
  | 'protocol'
  | 'sentryDsn'
  | 'sentryEnv'
  | 'supportMail'
  | 'trackSentry'
  | 'websocketProtocol';

type ComputedConfigValues = 'apiUrlFull' | 'wsUrlFull';

type Config = Record<ConfigValues, string>;

export type FullConfig = Record<ConfigValues | ComputedConfigValues, string>;

const getData = (): FullConfig => {
  const webpackConfig = (document.querySelector('meta[name="config"]') as HTMLMetaElement)?.dataset as Config;

  return {
    ...webpackConfig,
    apiUrlFull: `${webpackConfig.protocol}://${webpackConfig.apiUrl}/graphql`,
    wsUrlFull: `${webpackConfig.websocketProtocol}://${webpackConfig.apiUrl}/graphql`,
  };
};

export default getData();
